<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row
      type="flex"
      justify="space-between"
      align="middle"
      class="fast-run-container"
    >
      <el-col :span="24">
        <span>{{ $t("home.fastRun") }}</span>
      </el-col>
    </el-row>
    <el-card
      v-for="(item, index) in checkedMenu"
      :key="index"
      shadow="never"
      class="menu-item"
      @click.native="linkTo(item.link)"
    >
      <el-row type="flex" justify="space-between" :gutter="20">
        <el-col :span="2" align="middle" justify="center">
          <el-avatar :size="45" :icon="item.icon"></el-avatar>
        </el-col>
        <el-col :span="22">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" class="menu-name">
              {{ item.name }}
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="24">
              {{ item.description }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { fastRunOptions } from "@/mixins/fastRunOptions";
import { getHost } from "@/helpers/url";

export default {
  name: "home",
  mixins: [fastRunOptions],
  data() {
    return {
      fastRunPreset: null,
      checkedMenu: [],
      menu: [
        {
          name: this.$t("common.menu.paymentdocuments.bankPay.name"),
          description: this.$t("common.menu.paymentdocuments.bankPay.desc"),
          icon: "el-icon-bank-card",
          link: "bankpay",
          code: [75]
        },
        {
          name: this.$t("common.menu.paymentdocuments.packsReceipts.name"),
          description: this.$t(
            "common.menu.paymentdocuments.packsReceipts.desc"
          ),
          icon: "el-icon-files",
          link: "packsreceipts",
          code: [76]
        },
        {
          name: this.$t("common.menu.paymentdocuments.relationship.name"),
          description: this.$t(
            "common.menu.paymentdocuments.relationship.desc"
          ),
          icon: "el-icon-connection",
          link: "relationship",
          code: [76]
        },
        {
          name: this.$t("common.menu.paymentdocuments.assignOperators.name"),
          description: this.$t(
            "common.menu.paymentdocuments.assignOperators.desc"
          ),
          icon: "el-icon-place",
          link: "assignoperators",
          code: [76]
        },
        {
          name: this.$t("common.menu.paymentdocuments.controlPacks.name"),
          description: this.$t(
            "common.menu.paymentdocuments.controlPacks.desc"
          ),
          icon: "el-icon-folder-checked",
          link: "controlpacks",
          code: [77]
        },
        {
          name: this.$t("common.menu.paymentdocuments.controlInetPays.name"),
          description: this.$t(
            "common.menu.paymentdocuments.controlInetPays.desc"
          ),
          icon: "el-icon-shopping-cart-2",
          link: "controlinetpays",
          code: [77]
        },
        {
          name: this.$t("common.menu.subscribers.name"),
          description: this.$t("common.menu.subscribers.desc"),
          icon: "el-icon-user",
          link: "subscribers",
          code: [84]
        },
        {
          name: this.$t("common.menu.searchchange.errorpayments.name"),
          description: this.$t("common.menu.searchchange.errorpayments.desc"),
          icon: "el-icon-copy-document",
          link: "errorpayments",
          code: [44, 45]
        },
        {
          name: this.$t("common.menu.massinput.enteringPayments.name"),
          description: this.$t("common.menu.massinput.enteringPayments.desc"),
          icon: "el-icon-data-line",
          link: "enteringpayments",
          code: [40]
        },
        {
          name: this.$t("common.menu.massinput.enteringSubsidies.name"),
          description: this.$t("common.menu.massinput.enteringSubsidies.desc"),
          icon: "el-icon-data-analysis",
          link: "enteringsubsidies",
          code: [40]
        },
        // {
        //   name: this.$t("common.menu.acceptedshipment.name"),
        //   description: this.$t("common.menu.acceptedshipment.desc"),
        //   icon: "el-icon-reading",
        //   link: "acceptedshipment",
        //   code: [66]
        // },
        {
          name: this.$t("common.menu.reports.name"),
          description: this.$t("common.menu.reports.desc"),
          icon: "el-icon-document-copy",
          link: "reports",
          code: [66]
        }
      ]
    };
  },
  async created() {
    document.title = this.$t("home.title");
    // await this.ping();
    await this.getWbAccess({ login: this.user.login });

    const defaultPreset = this.fastRunOptions[0].value;
    const savedSettings = this.$localStorage.get("wb-settings");
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      this.fastRunPreset = settings.fastRunPreset || defaultPreset;
    } else {
      this.fastRunPreset = defaultPreset;
    }

    const currentPreset = this.fastRunOptions.find(
      item => item.value === this.fastRunPreset
    );
    if (currentPreset) {
      currentPreset.preset.forEach(item => {
        const presetItem = this.menu.find(menuItem => menuItem.link === item);
        if (presetItem && this.isAccess(presetItem.code))
          this.checkedMenu.push(presetItem);
      });
    }
  },
  computed: {
    ...mapGetters(["loading", "initPage", "wbAccess", "user"])
  },
  methods: {
    ...mapActions(["ping", "getWbAccess"]),
    linkTo(route) {
      this.$router.push(`/${route}`);
    },
    isAccess(code) {
      return code.some(v => this.wbAccess.includes(v));
    }
  }
};
</script>

<style scoped>
.fast-run-container {
  font-size: 1.3em;
  font-weight: bold;
  margin-bottom: 1em;
}
.menu-item {
  cursor: pointer;
  margin-bottom: 0.6em;
}
.menu-name {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.3em;
}
.menu-item:hover {
  background: var(--off-background-complementary-light);
}
.el-avatar {
  color: var(--main-headline-color);
  background-color: var(--off-background-color);
}
</style>
